import { AlertTriangle, PhoneCall, RotateCcw } from 'lucide-react'
import type { ReactNode } from 'react'
import { ScreenTitle, StateIcon } from '@/features/entry'

/**
 * P-11 "We couldn't book your appointment" (UserFlows P-11, default variant): the mockup's `MessageScreen` with the
 * compact contact block and "Try again" → P-08 with the day kept.
 */
export function BookFailedScreen({ onTryAgain, contact }: { onTryAgain: () => void; contact: ReactNode }) {
  return (
    <div className="state-screen">
      <StateIcon tone="error">
        <AlertTriangle />
      </StateIcon>
      <ScreenTitle className="pt-title">We couldn’t book your appointment</ScreenTitle>
      <p className="pt-sub">
        Something went wrong on our side, and your time wasn’t booked. Please try again, or contact us and we’ll book it
        for you.
      </p>
      {contact}
      <div className="pt-actions">
        <button type="button" className="btn btn-primary" onClick={onTryAgain}>
          <RotateCcw aria-hidden /> Try again
        </button>
      </div>
    </div>
  )
}

/**
 * P-11 outcome-unknown variant (UserFlows P-11 [New]; D-30; Security.md §7.5): PF didn't confirm in time, so the
 * booking may or may not exist. The compact contact block and **no "Try again"**, so the patient can't book twice.
 * Terminal: browser Back stays here.
 */
export function BookUnconfirmedScreen({ contact }: { contact: ReactNode }) {
  return (
    <div className="state-screen">
      <StateIcon tone="warn">
        <PhoneCall />
      </StateIcon>
      <ScreenTitle className="pt-title">We couldn’t confirm your booking</ScreenTitle>
      <p className="pt-sub">Your appointment may have been booked. Please call us to confirm before booking again.</p>
      {contact}
    </div>
  )
}
